import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

export const PageWrapper = styled(Box)(({ theme }) => `
  padding: 32px 40px;
  background: white;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    padding: 24px 20px;
  }
`);

export const HeroSection = styled(Box)(() => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
`);

export const HeroContent = styled(Box)(() => `
  flex: 1;
`);

export const HeroTitle = styled('h1')(() => `
  font-family: 'Toyota', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 112.2%;
  display: flex;
  align-items: center;
  color: #000000;
  margin: 0 0 4.37px 0;
`);

export const HeroSubtitle = styled('p')(({ theme }) => `
  font-family: 'Toyota', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 112.2%;
  color: #424242;
  margin: 0;
  max-width: 480px;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    font-size: 14px;
  }
`);

export const HeroImage = styled('img')(({ theme }) => `
  width: 275px;
  height: auto;
  flex-shrink: 0;
  margin-left: 64px;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    width: 180px;
    margin-left: 24px;
  }
`);

export const SearchSection = styled(Box)(() => `
  display: flex;
  align-items: stretch;
  margin-top: 25px; 
`);

export const SearchInputWrapper = styled(Box)(() => `
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`);

export const SearchInputIcon = styled('img')(() => `
  position: absolute;
  left: 14px;
  width: 20px;
  height: 19px;
  pointer-events: none;
  filter: brightness(0) saturate(100%) invert(60%);
`);

export const SearchInput = styled('input')(() => `
  width: 100%;
  border: 1px solid #E0E0E0;
  border-radius: 6px 0 0 6px;
  padding: 0 0 0 40px;
  height: 46px;
  font-size: 14px;
  color: #424242;
  outline: none;
  background: white;

  &::placeholder {
    color: #9E9E9E;
  }

  &:focus {
    border-color: #EB0A1E;
  }
`);

export const SearchBtn = styled('button')(() => `
  display: flex;
  align-items: center;
  gap: 6px;
  background: #EB0A1E;
  color: white;
  border: none;
  border-radius: 0px 6px 6px 0px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #c5081a;
  }
`);

export const AskAssistantBtn = styled('button')(({ theme }) => `
  display: flex;
  align-items: center;
  gap: 11px;
  background: white;
  color: #EB0A1E;
  border: 1px solid #EB0A1E;
  border-radius: 6px;
  padding: 14px;
  height: 46px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 20px;
  line-height: 94.2%;

  &:hover {
    background: #FFF5F5;
  }

  img {
    filter: brightness(0) saturate(100%) invert(12%) sepia(89%) saturate(5765%) hue-rotate(350deg) brightness(95%) contrast(107%);
  }

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    padding: 10px;
    margin-left: 12px;
    font-size: 13px;
    gap: 6px;
  }
`);

export const TryAskingSection = styled(Box)(() => `
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  margin: 0;
  margin-top: 28px;
`);

export const TryAskingLabel = styled('span')(() => `
  font-size: 14px;
  font-weight: 600;
  color: #000000;
`);

export const TryAskingChip = styled('button')(() => `
  background: white;
  border: 0.5px solid #EB0A1E;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 13px;
  color: #EB0A1E;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #FFF5F5;
  }
`);

export const SectionHeader = styled(Box)(() => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-column: span 3;
`);

export const SectionHeaderHowTo = styled(Box)(({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-column: span 4;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    grid-column: span 2;
  }
`);

export const SectionTitle = styled('h2')(() => `
  font-size: 18px;
  font-weight: 700;
  color: #212121;
  margin: 0;
`);

export const ViewAllLink = styled(Link)(() => `
  font-size: 13px;
  font-weight: 600;
  color: #EB0A1E;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`);

export const ContentRow = styled(Box)(({ theme }) => `
  display: flex;
  gap: 24px;
  margin-bottom: 18px;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    flex-direction: column;
    gap: 16px;
  }
`);

export const TopicsColumn = styled(Box)(({ theme }) => `
  width: 75%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    width: 100%;
  }
`);

export const TopicCardsGrid = styled(Box)(({ theme }) => `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  flex: 1;
  margin-top: 16px;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
`);

export const TopicCardsGridHowTo = styled(Box)(({ theme }) => `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  width: 100%;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
`);

export const TopicCard = styled(Box)(({ theme }) => `
  border: 1px solid rgba(66, 66, 66, 0.32);
  border-radius: 4px;
  padding: 14px;
  background: white;
  cursor: pointer;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  min-height: 150px;

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    min-height: 130px;
    padding: 12px;
  }
`);

export const TopicCardHeader = styled(Box)(() => `
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 8px;
`);

export const TopicCardIconWrapper = styled('div')(() => `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  background: #FFEEEF;
  color: #EB0A1E;

  img, svg {
    width: 24px;
    height: 24px;
  }
`);

export const TopicCardIcon = styled('img')(() => `
  width: 22px;
  height: 22px;
`);

export const TopicCardTitle = styled('h3')(() => `
  font-size: 16px;
  font-weight: 700;
  color: #212121;
  margin: 0;
  line-height: 112.2%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`);

export const TopicCardDescription = styled('p')(() => `
  font-size: 14px;
  color: #656363;
  margin: 0;
  line-height: 112.2%;
`);

export const TopicCardDocsCount = styled('div')(() => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
  color: #EB0A1E;
  margin-top: auto;
`);

export const RecentlyViewedSection = styled(Box)(({ theme }) => `
  width: 25%;
  flex-shrink: 0;
  border-radius: 12px;
  display: flex;
  flex-direction: column;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    width: 100%;
  }
`);

export const RecentlyViewedBox = styled(Box)(() => `
  height: 340px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid rgba(66, 66, 66, 0.32);
  margin-top: 16px;
  padding: 14px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(66, 66, 66, 0.28);
    border-radius: 3px;
  }
`);

export const RecentlyViewedTitle = styled('h3')(() => `
  font-size: 18px;
  font-weight: 700;
  color: #212121;
  margin: 0;
`);

export const RecentlyViewedItem = styled(Box)(() => `
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #EEEEEE;

  &:last-child {
    border-bottom: none;
  }
`);

export const RecentlyViewedIconBadge = styled('div')(() => `
  background: #FFEEEF;
  width: 22px;
  height: 23px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
`);

export const RecentlyViewedIcon = styled('img')(() => `
  width: 16.52px;
  height: 20.78px;
  margin-top: 2px;
  flex-shrink: 0;
`);

export const RecentlyViewedItemTitle = styled('div')(() => `
  font-size: 14px;
  font-weight: 600;
  color: #424242;
`);

export const RecentlyViewedItemTime = styled('div')(() => `
  font-size: 12px;
  color: #656363;
  margin-top: 2px;
`);

export const RecentlyViewedEmpty = styled(Box)(() => `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 16px;
`);

export const RecentlyViewedEmptyIcon = styled('div')(() => `
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #F4F5F7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  img {
    width: 28px;
    height: 28px;
    opacity: 0.55;
  }
`);

export const RecentlyViewedEmptyTitle = styled('div')(() => `
  font-size: 15px;
  font-weight: 700;
  color: #424242;
  margin-bottom: 6px;
`);

export const RecentlyViewedEmptyText = styled('div')(() => `
  font-size: 13px;
  color: #656363;
  line-height: 1.5;
  max-width: 220px;
`);

export const HowToCard = styled(Box)(() => `
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  padding: 10px;
  background: white;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }
`);

export const HowToCardIcon = styled('div')(({ theme }) => `
  width: 56px;
  height: 64px;
  border-radius: 4px;
  background: #FFEEEF;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 43px;
    height: 54.1px;
  }

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    width: 44px;
    height: 52px;

    img {
      width: 34px;
      height: 42px;
    }
  }
`);

export const HowToCardContent = styled(Box)(() => `
  flex: 1;
`);

export const HowToCardTitle = styled('h4')(() => `
  font-size: 14px;
  font-weight: 700;
  color: #212121;
  margin: 0 0 4px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`);

export const HowToCardDescription = styled('p')(() => `
  font-size: 12px;
  color: #616161;
  margin: 0;
  line-height: 1.4;
`);

export const HowToSection = styled(Box)(() => ``);

export const ActionArrow = styled('div')(() => `
  width: 25px;
  height: 25px;
  border-radius: 1000px;
  background: #FFE3E6;
  display: flex;
  justify-content: center;
  align-items: center;
`);

